export default "__VITE_ASSET__56f4dd48__"